function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button, Space, Image, Badge, Modal, Avatar, Alert, notification } from 'antd';
import { XSquareFill, PersonPlusFill, MenuButtonWideFill, List, EmojiSmileFill, BellFill, Cash } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import UserNavBar from '../components/navbars/UserNavBar';
import Common from '../components/includes/Common';
import Autorisations from '../components/Autorisations';
import InitiateCashout from '../components/forms/InitiateCashout';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
    Content = Layout.Content,
    Footer = Layout.Footer,
    Sider = Layout.Sider;

var Home = function Home() {
  var navigate = useNavigate();

  var _useParams = useParams(),
      userid = _useParams.userid;

  var _useState = useState(Common.currentUser),
      _useState2 = _slicedToArray(_useState, 2),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = useState(Common.account),
      _useState4 = _slicedToArray(_useState3, 2),
      account = _useState4[0],
      setAccount = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      menuDrawerVisible = _useState6[0],
      setMenuDrawerVisible = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showRequests = _useState8[0],
      setShowRequests = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      dataChanged = _useState10[0],
      setDataChanged = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      authProcessing = _useState12[0],
      setAuthProcessing = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      collapsed = _useState14[0],
      setCollapsed = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      requestsCount = _useState16[0],
      setRequestsCount = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showInitExpense = _useState18[0],
      setShowInitExpense = _useState18[1];

  useEffect(function () {
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: localStorage.getItem("userData") != "undefined" ? JSON.parse(localStorage.getItem('userData')).id : 0
    }).then(function (response) {
      setAuthProcessing(false);

      if (response.data.authenticated == 1) {
        setUser(response.data.user);
        setAccount(response.data.account);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        localStorage.setItem('accountData', JSON.stringify(response.data.account));
      } else {
        navigate('/');
      }
    })["catch"](function (error) {});

    if (user == null) {
      setUser(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  useEffect(function () {
    if (Common.currentUser == 'undefined') return;
    axios.get(Common.baseApiUrl + "getrequestscount/" + (localStorage.getItem("userData") != "undefined") ? JSON.parse(localStorage.getItem('userData')).id : 0).then(function (response) {
      if (response.data.status == 200) setRequestsCount(response.data.count);
    })["catch"](function (error) {})["finally"](function () {});
  }, [requestsCount]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsxs(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: [/*#__PURE__*/_jsxs(Sider, {
        collapsible: true,
        collapsed: collapsed,
        onCollapse: function onCollapse(value) {
          return setCollapsed(value);
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            height: 52,
            borderRadius: "5px",
            padding: "5px",
            margin: 16,
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center",
              margin: "0 auto"
            },
            children: /*#__PURE__*/_jsx(Image, {
              style: {
                height: "44px",
                borderRadius: "44px"
              },
              preview: false,
              width: "44px",
              fallback: "/drawables/user.png",
              src: Common.baseUrl + Common.currentUser.avatar
            })
          })
        }), /*#__PURE__*/_jsx(UserNavBar, {
          style: {
            background: "#464646"
          },
          handleMenuClose: function handleMenuClose() {
            setMenuDrawerVisible(false);
          }
        })]
      }), /*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 3,
                xs: 4,
                children: /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  style: {
                    overFlow: "hide"
                  },
                  children: Common.account == 'undefined' || Common.account.logo == null ? /*#__PURE__*/_jsx(Image, {
                    style: {
                      maxHeight: "60px"
                    },
                    preview: false,
                    width: "140px",
                    src: "drawables/cl.png"
                  }) : /*#__PURE__*/_jsx(Image, {
                    style: {
                      maxHeight: "60px"
                    },
                    preview: false,
                    width: "140px",
                    src: Common.baseUrl + Common.account.logo
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 4,
                  offset: 0
                },
                md: {
                  span: 4,
                  offset: 0
                },
                sm: {
                  span: 4,
                  offset: 0
                },
                xs: {
                  span: 5,
                  offset: 0
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EmojiSmileFill, {
                    size: 25
                  }), " ", user != null && ' ' + user.firstname, " , bonjour"]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 1,
                  offset: 2
                },
                md: {
                  span: 1,
                  offset: 2
                },
                sm: {
                  span: 2
                },
                xs: {
                  span: 2
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(_Fragment, {
                    children: (Common.currentUser.role == 99 || Common.currentUser.role == 98 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Badge, {
                      style: {
                        cursor: "pointer"
                      },
                      onClick: function onClick() {
                        setShowRequests(true);
                      },
                      count: requestsCount,
                      children: /*#__PURE__*/_jsx(BellFill, {
                        size: 22
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setShowInitExpense(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(Cash, {
                        size: 25
                      })
                    })
                  })]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(Content, {
          style: {
            margin: '0 16px',
            paddingTop: '20px'
          },
          children: [/*#__PURE__*/_jsx(Container, {
            children: account && account != 'undefined' && /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsx(Col, {
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    marginBottom: "10px"
                  },
                  children: [account.status == 0 && /*#__PURE__*/_jsx(Alert, {
                    type: "error",
                    showIcon: true,
                    message: "Votre compte est suspendu, veuillez revouveller votre plan"
                  }), account.status == 2 && /*#__PURE__*/_jsx(Alert, {
                    type: "warning",
                    showIcon: true,
                    message: "Pour garder votre compte actif veuillez revouveller votre plan"
                  }), account.status == 3 && /*#__PURE__*/_jsx(Alert, {
                    type: "warning",
                    showIcon: true,
                    message: "Pour garder votre compte actif veuillez revouveller votre plan"
                  }), account.status == 4 && /*#__PURE__*/_jsx(Alert, {
                    type: "warning",
                    showIcon: true,
                    message: "Pour garder votre compte actif veuillez revouveller votre plan"
                  })]
                })
              })
            })
          }), /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Outlet, {
              context: [dataChanged, setDataChanged]
            })
          })]
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "GuisoftLab \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showRequests,
        width: "85%",
        title: /*#__PURE__*/_jsx("b", {
          children: "DEMANDES"
        }),
        destroyOnClose: true,
        onClose: function onClose() {
          setShowRequests(false);
        },
        closable: true,
        children: /*#__PURE__*/_jsx(Autorisations, {})
      }), /*#__PURE__*/_jsx(Modal, {
        open: showInitExpense,
        width: "620px",
        title: /*#__PURE__*/_jsx("b", {
          children: "INITIER UNE SORTIE"
        }),
        destroyOnClose: true,
        onCancel: function onCancel() {
          setShowInitExpense(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(InitiateCashout, {
            operationType: 0,
            handler: function handler() {
              setShowInitExpense(false);
              notification.success({
                message: "Ok!",
                description: "Opération envoyée pour validation"
              });
            }
          })
        })
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};

export default Home;